import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import FormattedNumber from '../../../../services/translations/components/FormattedNumber'

export default class Currency extends PureComponent {
    static propTypes = {
        amount: PropTypes.number,
        currency: PropTypes.string.isRequired,
        maximumFractionDigits: PropTypes.number,
        minimumFractionDigits: PropTypes.number,
        placeholder: PropTypes.string,
    }

    static defaultProps = {
        amount: 0,
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
        placeholder: '-',
    }

    render() {
        const { amount, currency, placeholder, maximumFractionDigits, minimumFractionDigits } = this.props

        if (!amount) return placeholder

        return (
            <div>
                <FormattedNumber
                    value={amount}
                    style={'currency'} // eslint-disable-line react/style-prop-object
                    currency={currency}
                    minimumFractionDigits={minimumFractionDigits}
                    maximumFractionDigits={maximumFractionDigits}
                />
            </div>
        )
    }
}
